export default __webpack_public_path__ + "static/media/ksettings.bd0f14a6.png";